const HomeAnimation = () => {
  return (
    <>
      <div className="enter-home__animation">
        <div className="__bars-animation">
          <span className="bar-1"></span>
          <span className="bar-2"></span>
          <span className="bar-3"></span>
          <span className="bar-4"></span>
          <span className="bar-5"></span>
          <span className="bar-6"></span>
        </div>
      </div>
      <div className="enter-home__animation-bg"></div>
    </>
  );
};

export default HomeAnimation;
